import * as React from "react"

export const ArrowTopIcon = () => {
  return (
    <svg width="28" height="18" viewBox="0 0 28 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.611328 1.14003C6.75319 0.372295 20.1556 2.39035 24.6305 16.6044"
        stroke="#36393A"
        strokeLinejoin="round"
      />
      <path
        d="M26.4461 11.7341L24.9409 17.4532L20.1889 13.933"
        stroke="#36393A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
